import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

export const useStyles = makeStyles(() => createStyles({
  wrapper: {
    borderRight: '1px solid #E9E9E9',
    position: 'fixed',
    top: 0,
    left: 0,
    bottom: 0,
  },
  avatar: {
    width: '70px',
    height: '70px',
    borderRadius: '50%',
    position: 'relative',
    overflow: 'hidden',
    marginRight: '10px',
    background: ' #F2F2F2',
  },
  avatarImg: {
    height: '100%',
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
  },
  sidebarLink: {
    display: 'block',
    height: '50px',
    padding: '15px 30px',
    fontSize: '16px',
    lineHeight: '20px',
    color: '#201E2A',
    '&:hover': {
      color: '#6C59E6',
    },
    '&.active': {
      background: '#6C59E6',
      borderRadius: '8px',
      pointerEvents: 'none',
      fontWeight: 'bold',
      color: '#fff',
    },
  },
}));
